import { DANGER_DURATION_MS } from '../../config/gameplay';

export type DangerSample = Readonly<{
  entityId: string;
  coreAboveLine: boolean;
}>;

export class DangerTracker {
  private readonly startedAt = new Map<string, number>();

  public observe(
    samples: readonly DangerSample[],
    nowMs: number,
    isEligible: (entityId: string) => boolean,
  ): string | null {
    const seen = new Set<string>();
    const ordered = [...samples].sort((left, right) => left.entityId.localeCompare(right.entityId));

    for (const sample of ordered) {
      seen.add(sample.entityId);
      if (!sample.coreAboveLine || !isEligible(sample.entityId)) {
        this.startedAt.delete(sample.entityId);
        continue;
      }
      const existing = this.startedAt.get(sample.entityId);
      if (existing === undefined) {
        this.startedAt.set(sample.entityId, nowMs);
      } else if (nowMs - existing >= DANGER_DURATION_MS) {
        return sample.entityId;
      }
    }

    for (const entityId of this.startedAt.keys()) {
      if (!seen.has(entityId)) this.startedAt.delete(entityId);
    }
    return null;
  }

  public remove(entityId: string): void {
    this.startedAt.delete(entityId);
  }

  public clear(): void {
    this.startedAt.clear();
  }

  public warningElapsed(entityId: string, nowMs: number): number {
    const startedAt = this.startedAt.get(entityId);
    return startedAt === undefined ? 0 : Math.max(0, nowMs - startedAt);
  }
}
